var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    role: "img",
    "aria-label": "Folder with documents icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Folder with documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20c0-1.657 1.343-3 3-3h14l6-6h24c1.657 0 3 1.343 3 3v30c0 1.657-1.343 3-3 3H7c-1.657 0-3-1.343-3-3V20z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 14l6 6H10c-1.657 0-3 1.343-3 3v1h19l6-6z",
    fill: "#FFC870",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 12,
    rx: 2,
    fill: "#FFFFFF",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 32,
    height: 12,
    rx: 2,
    fill: "#FFFFFF",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 28,
    height: 12,
    rx: 2,
    fill: "#FFFFFF",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h24",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h18",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 50,
    rx: 16,
    ry: 3,
    fill: "#000",
    opacity: 0.06
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDocuments);
export default __webpack_public_path__ + "static/media/folder-documents.411c282b6e092356f9b03858b0c10ee6.svg";
export { ForwardRef as ReactComponent };